import MomentsHomePage from './MomentsHomePage';

import Home from '@/components/Home';
import { useMcpMemberFlag } from '@/hooks/useMcpMemberFlag';

// Legacy home while the flag loads, is off, or failed: unflagged members see no change.
const MemberHomeIndex = () => {
  const { enabled } = useMcpMemberFlag();
  return enabled ? <MomentsHomePage /> : <Home />;
};

export default MemberHomeIndex;
